import * as Yup from 'yup';
import { constantVar } from '../../utils/constant';
import { useTranslation } from 'react-i18next';

const AddVenueSchema = () => {
  const { t } = useTranslation()

  return Yup.object({
    name: Yup.string().required(t("addVenueModal.venueNameErrMsg")),
    bookingType: Yup.string().required(t("addVenueModal.bookingTypeErrMsg")),
    maxBookingHoursPerYear: Yup.string()
      .required(t("addVenueModal.maxBookingHrsErrMsg"))
      .matches(
        constantVar.numberPatten,
        t("addVenueModal.bookingHrsInNumber")
      ),
    maxHourPerBooking: Yup.number()
      .integer(
        t("addVenueModal.decimalNotAllowed")
      )
      .required(
        t("addVenueModal.maxHrsPerBookingErrMsg")
      )
      .typeError(
        t("addVenueModal.bookingHrsInNumber")
      )
      .test(
        "len",
        t("addVenueModal.maxHrs"),
        (val: any) => parseInt(val) <= 23
      ),
    start_time: Yup.string().required(
      t("addVenueModal.startTimeErrMsg")
    ),
    end_time: Yup.string().required(
      t("addVenueModal.endTimeErrMsg")
    ),
  });
};

export default AddVenueSchema